export enum CommandStatus {
  PENDING = 'PENDING',
  DONE = 'DONE',
  UNSUPPORTED = 'UNSUPPORTED',
  CONFLICT = 'CONFLICT',
  ERROR = 'ERROR',
  RESOLVED = 'RESOLVED',
}
